import React, { useState, useEffect } from 'react';
import api from '../../../../api/api.js';
import apifunctions from '../../../../api/functions.js';
import functions from '../../../../functions';

import imgNoDisponible from '../../../../../public/img/image-not-found.png';

export const FILTROS = [
  'Categorias', 'Rubros', 'Lineas', 'Materiales', 'Marcas', 'Grupos', 'Modelos'
].map((item, index) => (
  { orden: index, key: item, nameToDisplay: "", enabled: true })
);

export const ORDERS = [
  ['Categorias', 'Categoria_id'],
  ['Rubros', 'Rubro_id'],
  ['Lineas', 'Linea_id'],
  ['Materiales', 'Material_id'],
  ['Marcas', 'Marca_id'],
  ['Grupos', 'Grupo_id'],
].map((item, index) => ({ orden: index, key: item[1], nameToDisplay: item[0], enabled: false }));

const initialState = {
  NombreEmpresa: '',
  URLEmpresa: '',
  LogoEmpresa: imgNoDisponible,
  CantidadDecimales: 2,
  CategoriaDefectoArticulo: null,
  UsarDescripcionComoTituloDeArticulo: false,

  CriterioFiltrado: '',

  PuntoVentaAsignadoAWeb: '',
  CondicionDePagoDefecto: '',
  ListaDePreciosDefecto: '000001',

  AnnonymousUser_AllowVistaArticulos: false,
  AnnonymousUser_AllowVistaPreciosDeArticulos: false,
  AnnonymousUser_AllowVistaArticulosSinStock: false,

  Pedidos_AllowCrear: false,
  Pedidos_AllowExportar: false,
  Pedidos_AllowCrearSinStock: false,

  Stock_FiltrarDepositos: false,
  Stock_DepositosHabilitados: [],
  Stock_DescontarStockDeDepositos: false,

  LoggedClient_AllowLogin: false,
  LoggedClient_AllowImport: false,
  LoggedClient_AllowExport: false,
  LoggedClient_AllowCreation: false,
  LoggedClient_EsRevendedor: false,
  LoggedClient_AlmacenarComprobantesMovCC: false,

  MP_Allow: false,
  MP_PublicKey: '',
  MP_AccessToken: '',

  LoggedClient_AllowVistaArticulosSinStock: false,

  Filters: FILTROS,
  Orders: ORDERS,
};

const save = (state) => {
  const callback = () => window.location.reload();

  const data = {};
  Object.keys(state).forEach((attr) => {
    if (attr == "PuntoVentaAsignadoAWeb" && state.PuntoVentaAsignadoAWeb.length != 4) {
      let PuntoVentaAsignadoAWeb = state.PuntoVentaAsignadoAWeb;
      PuntoVentaAsignadoAWeb = PuntoVentaAsignadoAWeb.substring(0, 4);
      while (PuntoVentaAsignadoAWeb.length < 4) PuntoVentaAsignadoAWeb = `0${PuntoVentaAsignadoAWeb}`;
      data["PuntoVentaAsignadoAWeb"] = PuntoVentaAsignadoAWeb;
    } else if (attr == "Filters") {
      data["Filters"] = JSON.stringify(state[attr]);
    } else if (attr == "Orders") {
      data["Orders"] = JSON.stringify(state[attr]);
    } else data[attr] = state[attr];
  });

  apifunctions.put(api.gestion.core.configuracion, null, data, callback, callback, callback,);
};

const useConfigState = () => {
  const [state, updateState] = useState(initialState);

  const setState = (newState) => updateState({ ...state, ...newState });

  useEffect(() => {
    const getAndProcess = (reintento = 0) => {
      const failureCallback = () => {
        if (reintento > 3) {
          setState(initialState);
        } else {
          getAndProcess(reintento + 1);
        }
      }
      const successCallback = (response) => {
        if (response && response.data) {
          let newState = response.data;
          if (newState.LogoEmpresa == '') newState.LogoEmpresa = imgNoDisponible;
          if (newState.Filters.length == 0) FILTROS.forEach(f => newState.Filters.push(f));
          if (newState.Orders.length == 0) ORDERS.forEach(f => newState.Orders.push(f));
          setState(newState);
        } else {
          setState(initialState);
        }
      }
      apifunctions.get(api.gestion.core.configuracion, null, null, {}, successCallback, failureCallback, failureCallback);
    };
    getAndProcess();
  }, []);

  return { state, initialState, setState, updateState, save };
}

export default useConfigState;


// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Configuracion/useConfigState.js